import { selectedChildId } from "@/store/parent/session";

export default function requireParentChild({ next }) {
  if (selectedChildId.value == null || selectedChildId.value === "") {
    return next({ name: "ParentChildren" });
  }
  return next();
}
